import React, { useEffect, memo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { useFormik } from 'formik';
import useFormikHelpers from '../hooks/useFormikHelpers';
import { classNames } from 'primereact/utils';

const APIS = ['CBD 1%', 'CBD 1,5%', 'CBD 3%', 'CBD 5%', 'CBD 10%', 'Matico', 'Arnika', 'Mentol', 'Bengue'];
const BASES = ['Gel', 'Cold Cream', 'Ungüento', 'Oil Free', 'Transdérmica', 'Novobase'];

const CreamsQuoter = ({ product, validating, onDataChange, disabled }) => {
    const initialValues = {
        baseCream: product.baseCream,
        quantity: product.cantidad || 1,
        api1: product.api1,
        api2: product.api2,
        api3: product.api3,
        api4: product.api4,
        unitPrice: product.precio_unitario,
        totalPrice: product.precio_unitario * product.cantidad,
    };

    const validateForm = (data) => {
        const errors = {};

        if (!data.baseCream) {
            errors.baseCream = 'Por favor selecciona una crema base';
        }

        if (!data.quantity) {
            errors.quantity = 'Cantidad no es válida';
        }

        if (!data.api1) {
            errors.api1 = 'Por favor selecciona al menos una API';
        }

        if (!data.unitPrice) {
            errors.unitPrice = 'Precio no válido';
        }

        return errors;
    };

    // const onSubmit = (data) => {
    //     console.log(data);
    // };

    const onValueChange = (event) => {
        formik.setFieldValue(event.target.name, event.value);
    };

    const formik = useFormik({ initialValues, validate: validateForm });

    const { isFormFieldInvalid, getFormErrorMessage } = useFormikHelpers(formik);

    useEffect(() => {
        formik.setFieldValue('totalPrice', (formik.values.quantity || 0) * (formik.values.unitPrice || 0));
    }, [formik.values.quantity, formik.values.unitPrice]);

    useEffect(() => {
        if (validating) {
            formik.submitForm();
        }
    }, [validating]);

    useEffect(() => {
        onDataChange(formik);
    }, [formik]);

    return (
        <div className="row gy-4">
            <div className="col-12 col-lg-6">
                <label>Base Crema: </label>
                <Dropdown
                    name="baseCream"
                    value={formik.values.baseCream}
                    onChange={onValueChange}
                    className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('baseCream') })}
                    options={BASES}
                    placeholder="Seleccione base"
                    showClear
                    disabled={disabled}
                />
                {getFormErrorMessage('baseCream')}
            </div>
            <div className="col-12 col-lg-6">
                <label htmlFor="quantity">Cantidad:</label>
                <InputNumber
                    name="quantity"
                    value={formik.values.quantity}
                    onValueChange={onValueChange}
                    className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('quantity') })}
                    locale="es-CL"
                    min={0}
                    showButtons
                    disabled={disabled}
                />
                {getFormErrorMessage('quantity')}
            </div>

            <div className="col-12 col-lg-6">
                <label>API 1: </label>
                <Dropdown
                    name="api1"
                    value={formik.values.api1}
                    onChange={onValueChange}
                    className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('api1') })}
                    options={APIS}
                    placeholder="Seleccione API"
                    showClear
                    disabled={disabled}
                />
                {getFormErrorMessage('api1')}
            </div>
            <div className="col-12 col-lg-6">
                <label>API 2: </label>
                <Dropdown
                    name="api2"
                    value={formik.values.api2}
                    onChange={onValueChange}
                    className="form-component"
                    options={APIS}
                    placeholder="Seleccione API"
                    showClear
                    disabled={disabled}
                />
            </div>
            <div className="col-12 col-lg-6">
                <label>API 3: </label>
                <Dropdown
                    name="api3"
                    value={formik.values.api3}
                    onChange={onValueChange}
                    className="form-component"
                    options={APIS}
                    placeholder="Seleccione API"
                    showClear
                    disabled={disabled}
                />
            </div>
            <div className="col-12 col-lg-6">
                <label>API 4: </label>
                <Dropdown
                    name="api4"
                    value={formik.values.api4}
                    onChange={onValueChange}
                    className="form-component"
                    options={APIS}
                    placeholder="Seleccione API"
                    showClear
                    disabled={disabled}
                />
            </div>

            <div className="col-12 col-lg-6">
                <label>Valor Unitario: </label>
                <div className={classNames('p-inputgroup', 'form-component', { 'p-invalid': isFormFieldInvalid('unitPrice') })}>
                    <span className="p-inputgroup-addon">$</span>
                    <InputNumber name="unitPrice" value={formik.values.unitPrice} onValueChange={onValueChange} locale="es-CL" min={0} disabled={disabled} />
                </div>
                {getFormErrorMessage('unitPrice')}
            </div>
            <div className="col-12 col-lg-6">
                <label>Valor Total: </label>
                <div className="p-inputgroup form-component">
                    <span className="p-inputgroup-addon">$</span>
                    <InputNumber
                        name="totalPrice"
                        value={formik.values.totalPrice}
                        onValueChange={onValueChange}
                        locale="es-CL"
                        min={0}
                        readOnly
                        disabled={disabled}
                    />
                </div>
            </div>
        </div>
    );
};

export default memo(CreamsQuoter);
